import { MarkovDataset } from "server/models"

export interface MarkovDatasetProps {
    datasetId: number
}

export type MarkovDatasetValidation = { [key in keyof MarkovDataset]?: string}

export interface MarkovDatasetState {
    datasets: MarkovDataset[]
    datasetSelected: MarkovDataset
    datasetEdit: MarkovDataset

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_DATASETS = "MARKOV_DATASETS"
export const MARKOV_DATASET_SELECTED = "MARKOV_DATASET_SELECTED"
export const MARKOV_DATASET_EDIT = "MARKOV_DATASET_EDIT"

export const MARKOV_DATASET_RELOAD_LIST = "MARKOV_DATASET_RELOAD_LIST"
export const MARKOV_DATASET_RELOAD_EDIT = "MARKOV_DATASET_RELOAD_EDIT"
